import { SWRConfiguration } from 'swr';

import { EmployeeFormType } from '~/data/documents/types';
import { UseArraySWROutput, useArraySWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

export const saveEmployeeForm = async (
  employeeId: number,
  submissionData: FormData,
  updateFormId?: number,
) => {
  if (!!updateFormId) {
    return await fetchFromOldApi(
      `/form/form/employee/${employeeId}/${updateFormId}`,
      {
        method: 'PUT',
        body: submissionData,
      },
    ).then((r) => r.json());
  } else {
    return await fetchFromOldApi(`/form/form/employee/${employeeId}`, {
      method: 'POST',
      body: submissionData,
    }).then((r) => r.json());
  }
};

export const deleteEmployeeForm = async (
  employeeId: number,
  formId: number,
) => {
  return await fetchFromOldApi(`/json/form/employee/${employeeId}/${formId}`, {
    method: 'DELETE',
  }).then((r) => r.json());
};

export const getEmployeeForms = (
  employeeId: number,
): Promise<EmployeeFormType[]> =>
  fetchFromOldApi(`/json/form/employee/${employeeId}`).then((r) => r.json());

type PropsType = {
  employeeId?: number;
};

export const useGetEmployeeForms = (
  props: PropsType,
  swrConfig?: SWRConfiguration,
  isDisabled?: boolean,
): UseArraySWROutput<EmployeeFormType> => {
  const { employeeId } = props;

  return useArraySWR(
    !isDisabled && !!employeeId ? ['employeeForms', employeeId] : null,
    ([_key, employeeId]: [string, number]) =>
      getEmployeeForms(employeeId).then((data) => {
        return data.sort((a: EmployeeFormType, b: EmployeeFormType) => {
          return (
            new Date(b.fEmpFormCreatedTime).valueOf() -
            new Date(a.fEmpFormCreatedTime).valueOf()
          );
        });
      }),
    swrConfig,
  );
};
